import type React from 'react';
import type { TenantContactMessage } from 'src/types';
import { LumiStatusLabels } from 'src/components/job-slide-out/components/nav-table/tenant-lula-chat/utils';

interface LumiMessageProps {
	message: TenantContactMessage;
}

const LumiMessage: React.FC<LumiMessageProps> = ({ message }) => {
	const label = LumiStatusLabels[message.lumi_status || ''];
	return (
		<div className="tenant-texts__row tenant-texts__row--system">
			<div className="tenant-texts__lumi">
				<h4 className="tenant-texts__lumi-title">LuMi Troubleshooting</h4>
				{label ? (
					<div
						className={`tenant-texts__lumi-tag tenant-texts__lumi-tag--${message.lumi_status}`}
					>
						{label}
					</div>
				) : null}
			</div>
		</div>
	);
};

export default LumiMessage;
